import styled from 'styled-components'

export const Container = styled.div`
  border: 1px solid #2c2c32;
  border-radius: 9px;
  margin-bottom: 4rem;

  h3 {
    margin: 0;
    font-size: 1.375rem;
    line-height: 1.625rem;
    font-weight: 700;
    color: #fff;
    padding: 10px;
  }

  .texts {
    display: flex;
    flex-direction: row;
  }

  @media only screen and (min-width: 1100px) {
    margin-top: 1rem;
  }
`

export const AnnotationListWrapper = styled.div`
  max-height: 570px;
  overflow: auto;
  margin: 5px 15px;

  @media only screen and (min-width: 1090px) {
    .line-note:hover .bin {
      display: block;
      background: none;
      border: none;
      color: #fff;
      cursor: pointer;
      margin: 5px 19px;
    }
  }
`

export const AnnotationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem;
  margin: 1rem 0 0 0;
  border-radius: 0 2px 2px 0;
  background: #1a1a1a;
  border-left: 3px solid #ff6600;
  max-height: 5rem;
  max-width: 100%;

  span {
    font-size: 1rem;
    line-height: 1.375rem;
    font-weight: 700;
    color: #fff;
  }

  p {
    font-size: 0.875rem;
    line-height: 1.25rem;
    font-weight: 400;
    color: #fff;
    margin-left: 0.5rem;
    padding-right: 0.5rem;
    word-break: break-word;
    width: 80%;
    height: 3.5rem;
    overflow: auto;
    ::-webkit-scrollbar {
      width: 2px;
    }
  }
  .bin {
    display: block;
    background: none;
    border: none;
    color: #fff;
    cursor: pointer;
  }
  @media only screen and (min-width: 1090px) {
    .bin {
      display: none;
    }
  }
`

export const AddAnnotationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem;

  margin: 1rem 15px;

  border-radius: 2px;

  background: #1a1a1a;

  input {
    width: 100%;
    background: none;
    border: none;

    color: #fff;

    ::placeholder {
      color: #fff;
    }
  }

  .plus-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ff6600;
    color: #fff;
    border: none;
    border-radius: 50%;
    width: 1.5rem;
    height: 1.5rem;

    svg {
      min-height: 1rem;
      min-width: 1rem;
    }
  }
`

export const WrapperContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0.5);
  max-width: 1300px;
  margin: 0 auto;
  padding: 1rem;
  z-index: unset;
`

export const Modal = styled.div`
  width: 80%;
  max-width: 1300px;
  border-radius: 13px;
  padding: 1.5rem;
  margin: 0 auto;
  border: solid 1px;

  @media only screen and (min-width: 1090px) {
    width: 50%;
  }

  textarea {
    width: 100%;
    max-width: 100%;
    max-height: 150px;
    height: 150px;
  }
`
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  @media only screen and (min-width: 1100px) {
    flex-direction: column-reverse;
  }
`

export const ButtonsSendCancel = styled.div`
  display: flex;
  justify-content: right;
  border: none;

  button {
    border-radius: 5px;
    padding: 10px 15px 10px 15px;
    border: none;
  }

  .save-button {
    margin-left: 0.7rem;
    border-radius: 5px;
    background-color: #ff6600;
    color: white;
    border: none;
  }
`
